<script lang="ts" setup></script>

<template>
  <UModal :default-open="true">
    <template #title>
      <h1>{{ $t("errors.offline.unable-to-sync") }}</h1>
    </template>
    <template #body>
      <div class="space-y-4">
        <p class="text-sm text-gray-500">
          {{ $t("errors.limit.exceeded") }}
        </p>
      </div>
    </template>
  </UModal>
</template>

<style></style>
